import React, { useState, useCallback, useEffect } from "react";

import moment from "moment-timezone";

import DateRangePickerDropdown from "@components/dateRange/DropdownDateRange";
import Button from "@components/tailwindComponents/Button";
import ListboxStatus from "@components/tailwindComponents/ListBoxWithStatus";

import { TASK_STATUS_LIST } from "../../utils/constants";

export default function Header({ t, setDataFilter, classParent, classChild, classButton, classSubChild = "arh-w-1/3", filtersLists, isOpen = false }) {
  const [status, setStatus] = useState({});
  const [dateChanged, setDateChanged] = useState(false);
  const [period, setPeriod] = useState({
    startDate: moment().subtract(3, "month").toDate(),
    endDate: moment().toDate(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });

  useEffect(() => {
    if (!dateChanged) {
      setDateChanged(true);
    }
  }, [period]);

  useEffect(() => {
    if (filtersLists && isOpen) {
      const { status, period } = filtersLists;
      if (period?.startDate && period?.endDate) setPeriod(period);
      if (status) setStatus(TASK_STATUS_LIST?.map((_status) => ({ ..._status, name: t(_status?._id) }))?.find((_status) => _status?._id === status))
    }
  }, [filtersLists, isOpen])

  const handleChangePeriod = useCallback(
    (date) => {
      setPeriod(date?.[0]);
    },
    [period],
  );
  const resetDateFilter = () => {
    setPeriod({
      startDate: null,
      endDate: null,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
  };
  const onApplyFilter = async () => {
    // let nPeriod = period;
    // if (!nPeriod?.startDate || !nPeriod?.endDate) {
    //   nPeriod = {
    //     startDate: moment().subtract(3, "month").toDate(),
    //     endDate: moment().toDate(),
    //     timezone:Intl.DateTimeFormat().resolvedOptions().timeZone
    //   };
    //   setPeriod(nPeriod);
    // }
    const data = {
      period,
      status: status?._id,
    };
    await setDataFilter(data, dateChanged);
    setDateChanged(false);
  };

  const listsStatus = TASK_STATUS_LIST.map((list) => ({
    ...list,
    name: t(list._id),
  }));

  return (
    <div className={classParent}>
      <div className={classChild}>
        <div className={classSubChild}>
          <ListboxStatus
            placeholder={t("Trier par statut")}
            name="status"
            optionList={listsStatus}
            selectedValue={status}
            setSelectedValue={setStatus}
            showReset={!!status?._id}
            toLeft={true}
            noRadio={true}
            color="checked:arh-bg-greenColor"
            spaceLabelAndText="arh-space-x-4"
          />
        </div>
        <div className={`datepicker_modals_parcours ${classSubChild} `}>
          <div className="dateRange_green DateRangePicker_customisation DateRangePicker_customisation--green arh-relative">
            <DateRangePickerDropdown
              key="date_range_periode"
              classParent="arhDatePicker"
              idInput="daterange"
              className="input_simple"
              dateSelected={period}
              textInput={t("Période")}
              SaveCloseRange={handleChangePeriod}
              showResetFilter={
                period.startDate && period.endDate ? true : false
              }
              onResetFilter={resetDateFilter}
              classSwitch="c-switch-pill-checked--green--color--to--left"
              classBackground="green"
            />
          </div>
        </div>
      </div>
      <div className={classButton}>
        <div className={classSubChild}>
          <Button onClick={onApplyFilter}>{t("Appliquer")}</Button>
        </div>
      </div>
    </div>
  );
}
